import { render, staticRenderFns } from "./create_new.vue?vue&type=template&id=d4aac9e0&scoped=true"
import script from "./create_new.vue?vue&type=script&lang=js"
export * from "./create_new.vue?vue&type=script&lang=js"
import style0 from "./create_new.vue?vue&type=style&index=0&id=d4aac9e0&prod&scoped=true&lang=css"
import style1 from "./create_new.vue?vue&type=style&index=1&id=d4aac9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aac9e0",
  null
  
)

export default component.exports